import { Component } from '@angular/core';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { ActionComponent } from '../../../ui/api/action.component';
import { ResultComponent } from '../../../ui/api/result.component';
import { ProductViewAddToBasketComponent } from '../view-add-to-basket/product-view-add-to-basket.component';
@Component({
    selector: 'quick-add-to-basket',
    templateUrl: 'quick-add-to-basket.html',
    standalone: true,
    imports: [ResultComponent, ActionComponent, SizeClassDirective]
})
export class QuickAddToBasketComponent extends ProductViewAddToBasketComponent {
    override get buttonCopy() {
        return this.getButtonLevelWarning() || this.getIfAddedToBasket() || this.translationService.transform('Add to Bag');
    }

    protected override getIfAddedToBasket(): string | undefined {
        if (this.addedToBasket) {
            return this.translationService.transform('Added to Bag');
        }
    }

    protected override onSuccess(): void {
        super.onSuccess();
        this.addedToBasket = true;
        if (this.app.isPlatformBrowser) {
            const minibasketScriollElement = document?.getElementById('minibasket-scroll');
            if (minibasketScriollElement) {
                minibasketScriollElement.scrollTo({ top: 0, behavior: 'smooth' });
            } else if (this.app.meta.state?.url === '/basket') {
                this.scrollToService.scrollTo(0);
            }
        }
    }
}
